import { useDispatch } from 'react-redux';
import { type ThunkDispatcher } from '../stores/types';

export default function useThunkDispatcher(): ThunkDispatcher {
  return useDispatch<ThunkDispatcher>();
}
